module.exports = __webpack_public_path__ + "static/media/mobito-new-logo.ab6ec026.svg";